import {
  defaultProps,
  FONT_FAMILY,
  GLOBAL_FONT_SIZE_NAMESPACE,
} from './fonts.config'

export const setFontSize = (size: string | number) => {
  const computedSize = typeof size === 'number' ? `${size}px` : size

  return `${GLOBAL_FONT_SIZE_NAMESPACE}: ${computedSize}`
}

export const makeFontFamilyFactory =
  (fonts?: string, baseFont = FONT_FAMILY) =>
  () => {
    if (!fonts) {
      return `font-family: ${baseFont};`
    } else {
      return `
      font-family: ${fonts}, ${baseFont};
    `
    }
  }

export const makeFontFamily = (fonts: string) => {
  return makeFontFamilyFactory(fonts, FONT_FAMILY)
}

type Props = {
  varName?: string
  baseFontSize: number
  fontSize: number
}
/**
 * Generates the CSS style rules for dynamic font-size based on the global
 * font-size. This function uses CSS variables + calc to determine the correct
 * font-size, with a fallback for a px font-size for browsers that don't
 * support CSS variables (IE).
 */
export const variableFontSize = (props: Partial<Props> = defaultProps) => {
  const { varName, baseFontSize, fontSize } = {
    ...defaultProps,
    ...props,
  }
  const variableNameSpace = `--${varName}-${fontSize.toString()}`

  const dynamicProp = `calc(${fontSize} / ${baseFontSize} * var(${GLOBAL_FONT_SIZE_NAMESPACE}, ${baseFontSize}px))`

  if (varName) {
    return `
      ${variableNameSpace}: ${dynamicProp};
      font-size: var(${variableNameSpace}, ${fontSize}px);
    `
  } else {
    return `
      font-size: ${dynamicProp};
    `
  }
}
